import { Box } from "@mui/material"
import {
  FocusContext,
  useFocusable,
} from "@noriginmedia/norigin-spatial-navigation"
import React from "react"

import { dimensions } from "../../utilities/constants"
import { useRouteMatch } from "../../utilities/use-route-match"

import { EmptyState, emptyStates } from "./components/EmptyState"

export const EmptyScreen = ({ visible }: { visible: boolean }) => {
  const isMyRoute = useRouteMatch()
  const { focusKey, ref } = useFocusable({
    saveLastFocusedChild: false,
    focusable: visible && isMyRoute,
  })

  return (
    <FocusContext.Provider value={focusKey}>
      <Box
        ref={ref}
        sx={{
          overflow: "visible",
          width: dimensions.width,
          display: visible ? "block" : "none",
        }}
      >
        <>
          {emptyStates.map((_, i) => (
            <EmptyState key={"EmptySlider" + i} index={i} />
          ))}
        </>
      </Box>
    </FocusContext.Provider>
  )
}
